import SsoLogics from '@/components/auth/sso-logics/SsoLogics';
import { Loader } from '@/components/ui/icons/Loader';

const SsoPage = () => {
	return (
		<>
			<Loader width='100px' />
			<SsoLogics />
		</>
	);
};

export default SsoPage;
